import { jsx as t } from "react/jsx-runtime";
import { memo as l } from "react";
import { u as i } from "../styled-components.browser.esm-BFmoFexH.js";
import n from "../metricDetails/MetricDetails.js";
const h = l(({
  metric: e,
  metricAliasFormatter: r = (o) => o
}) => /* @__PURE__ */ t(a, { children: /* @__PURE__ */ t(n, { metric: e, children: /* @__PURE__ */ t(s, { title: e.metricAlias, children: r(e.metricAlias) }) }) })), a = i.div`
  display: flex;
  gap: 5px;
    align-items: center;
    height: 100%;
`, s = i.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 250px;
    align-content: center;
`;
export {
  h as default
};
//# sourceMappingURL=MetricDisplay.js.map
